// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1VFMp","ranges":"BmiRanges_ranges__1nnsB"};